module.exports = __webpack_public_path__ + "static/img/map_new.7eec72c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/map_new.png
// module id = bbkq
// module chunks = 0